import { Control, Controller, FieldError } from 'react-hook-form';
import { StanDropdown } from '@/components';
import { DropdownValue } from '@/components/core-components/StanDropdown/StanDropdown.types';
import { AutomationFormData } from '../../validations/automationForm';

interface TriggerSelectorProps {
    control: Control<AutomationFormData>;
    error?: FieldError;
}

const TRIGGER_OPTIONS: DropdownValue[] = [
    {
        value: 'message',
        label: 'When they DM',
    },
    {
        value: 'comment',
        label: 'When they Comment',
    },
    {
        value: 'all',
        label: 'When they DM or Comment',
    },
];

/**
 * TriggerSelector - Dropdown for selecting automation trigger type
 * Allows users to choose between DMs, Comments, or Both
 */
export const TriggerSelector = ({ control, error }: TriggerSelectorProps) => {
    return (
        <Controller
            name='trigger_source'
            control={control}
            render={({ field }) => {
                const currentValue = TRIGGER_OPTIONS.find(opt => opt.value === field.value) || TRIGGER_OPTIONS[2];

                const handleSelect = (value: DropdownValue) => {
                    field.onChange(value.value);
                };

                return (
                    <StanDropdown
                        id='trigger-source'
                        name='trigger-source'
                        options={TRIGGER_OPTIONS}
                        currentValue={currentValue}
                        onSelect={handleSelect}
                        error={!!error}
                        hintText={error?.message}
                        preventDeselect
                    />
                );
            }}
        />
    );
};
